import { HttpClient } from '@angular/common/http';
import { GridReadyEvent, FilterModel, AdvancedFilterModel, ICellRendererParams, ColDef, GridApi, IServerSideDatasource, RowModelType, GridOptions, GridPreDestroyedEvent, GetRowIdFunc, GetRowIdParams, IServerSideGetRowsParams, SortModelItem, StateUpdatedEvent, ValueGetterParams } from 'ag-grid-community';
import { IconCellRendererComponent } from '../icon-cell-renderer/icon-cell-renderer.component';
import 'ag-grid-enterprise';
import { StoreReport } from '../models/store-report.model';
import { storeReportDefaultGridState } from '../default-grid-states/store-report-default-grid-state';
import { UserGridStateService } from '../user-grid-state.service';
import { PalletRacksModalComponent } from '../pallet-racks/pallet-racks-modal/pallet-racks-modal.component';
import { LadingStatusModalComponent } from 'src/app/lading-status-modal/lading-status-modal.component';
import { ToastrService } from 'ngx-toastr';
import { NgZone } from '@angular/core';
import { Component, Input, ViewChild } from '@angular/core';

@Component({
  selector: 'app-store-reports',
  templateUrl: './store-reports.component.html',
  styleUrls: ['./store-reports.component.scss']
})
export class StoreReportsComponent {
  private apiUrl = '/api/store_reports/store_reports.php';
  public theme: string ="ag-theme-ulaap";
  public rowModelType: RowModelType = 'serverSide';
  public cacheBlockSize = 100;
  public cacheOverflowSize = 2;
  public maxConcurrentDatasourceRequests = 2;
  public infiniteInitialRowCount = 1;
  public initialState = JSON.parse(JSON.stringify(storeReportDefaultGridState));
  public gridReady = false;
  public gridVisible = true;
  public gridOptions: GridOptions = {};
  private gridApi!: GridApi<StoreReport>;
  public rowData?: StoreReport[];
  public defaultColDef: ColDef = {
    sortable: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      caseSensitive: false,
      buttons: ['apply','clear','reset']
    },
    autoHeight: true,
    resizable: true
  }
  public columnDefs: ColDef[] = [
    {
      headerName: '', 
      editable: false, 
      width: 50,      
      cellRenderer: (params: any) => {
        const button = document.createElement('button');
        const icon = document.createElement('i');

        // Add Font Awesome classes to the icon element
        icon.classList.add('fas', 'fa-edit'); 

        // Append the icon to the button
        button.appendChild(icon);
        button.addEventListener('click', () => {
          this.zone.run(() => {
            this.openStatusModal(params);
          });
        });
        return button;
      }, 
    },       
    { field: 'trip_number', headerName: 'Batch ID'},    
    { field: 'asn_number', headerName: 'Master BOL'},     
    { field: 'customer_name', headerName: 'Customer'},
    { field: 'alternate_reference', headerName: 'FBI #', width: 100}, 
    { field: 'store_number', headerName: 'Store'},
    { field: 'week_no', headerName: 'Week No.', filter: 'agNumberColumnFilter',
      filterParams: {
        filterOptions: ['equals','notEqual','lessThan','lessThanOrEqual','greaterThan','greaterThanOrEqual','inRange']
      }
    },
    { field: 'external_bill_of_lading', headerName: 'BOL #'},
    { field: 'total_cartons', headerName: 'Carton Count', filter: 'agNumberColumnFilter'},
    { field: 'load_start', headerName: 'Shipped Date', filter: 'agDateColumnFilter',  valueGetter: params => this.formatDateString(params.data.load_start)},
    { field: 'local_time', headerName: 'Actual Delivery Date',
      filter: 'agDateColumnFilter',
      valueGetter: params => this.formatDateString(params.data.local_time),
    },
    { field: 'local_time', headerName: 'Actual Delivery Time',
      filter: false,
      valueGetter: params => this.formatTimeString(params.data.local_time)
    },
    { field: 'consignee_locality', headerName: 'Consignee City', filter: false},
    { field: 'consignee_region', headerName: 'Consignee Prov', filter: false},
    { field: 'consignee_contact_date', headerName: 'Date Store Was Called', filter: 'agDateColumnFilter',
      // filterParams: {
      //   filterOptions: ['equals','notEqual','before','after','inRange']
      // }
    },    
    { field: 'appointment_date', headerName: 'Appt Date', filter: 'agDateColumnFilter', valueGetter: params => this.formatDateString(params.data.appointment_date),
      // filterParams: {
      //   filterOptions: ['equals','notEqual','before','after','inRange']
      // }
    },
    { field: 'appointment_window', headerName: 'Appointment Window', filter: false},
    { field: 'delivery_status', headerName: 'On-Day?', cellRenderer: this.deliveryDayStatusFormatting},
    { field: 'lading_status', headerName: 'Status'},
    { field: 'operation_delays', headerName: 'Operation Delays', filter: false},    
    //{ field: 'asn_number', headerName: 'ASN Number'},
    //{ field: 'consignee_region', headerName: 'Region'},
    //{ field: 'outbound_scan_date', headerName: 'Outbound Scan Date', filter: 'agDateColumnFilter', valueGetter: params => params.data.outbound_scan_date !== null ? params.data.outbound_scan_date.split(' ')[0] : '',
      // filterParams: {
      //   filterOptions: ['equals','notEqual','before','after','inRange']
      // }
    //},
    //{ field: 'first_delivered_scan', headerName: 'First Delivered Scan', filter: 'agDateColumnFilter', valueGetter: params => params.data.first_delivered_scan !== null ? params.data.first_delivered_scan.slice(0,-3) : '',
      // filterParams: {
      //   filterOptions: ['equals','notEqual','before','after','inRange']
      // }
    //},
    //{ field: 'last_delivered_scan', headerName: 'Last Delivered Scan', filter: 'agDateColumnFilter', valueGetter: params => params.data.last_delivered_scan !== null ? params.data.last_delivered_scan.slice(0,-3) : '',
      // filterParams: {
      //   filterOptions: ['equals','notEqual','before','after','inRange']
      // }
    //},
    // { field: 'time_zone_id', headerName: 'Time Zone', hide: true}
  ]

  lading_uuid: string = '';

  // Modal to add lading status
  @ViewChild(LadingStatusModalComponent) lading_status_modal!: LadingStatusModalComponent;
  isStatusModalOpen: boolean = false;

  openStatusModal(params: any) 
  { 
      this.isStatusModalOpen = true; 
      this.lading_uuid = params.data.lading_uuid;
      console.log('Lading UUID:' + this.lading_uuid);
  }
  closeStatusModal(update_successful: any) { 
    this.isStatusModalOpen = false; 
    if(update_successful == 1){
      this.toastr.success("Status successfully updated!");
    }
    else if (update_successful == 2){
      this.toastr.error("Status was not updated.");
    }
  }

  constructor(private http: HttpClient, private gridStateService: UserGridStateService, private zone: NgZone, private toastr: ToastrService){}

  ngOnInit(){
    this.fetchAndApplyGridState();
  }

  // changes column names in filterModel for columns that appear in multiple tables referenced in SQL query
  // also switches date values for bad date ranges (dateTo <--> dateFrom)
  private translateFilters(filterModel: any): any {
    const aliasMapping: {[key: string]: string} = {
      "alternate_reference": "lading.alternate_reference",
      "asn_number": "shipment_list.asn_number",
      "external_bill_of_lading": "shipment_list.external_bill_of_lading",
      "store_number": "shipment_list.store_number",
      "outbound_scan_date": "products.date",
      "first_delivered_scan": "products.delivered_time",
      "last_delivered_scan": "products.delivered_time"
      //"blah_blah": "blahblah.foo_bar",
      //moar mappings
    };

    const translatedFilters: { [key: string]: any} = {};
    for (const alias in filterModel) {
      // switches date values if needed
      if(filterModel[alias].type === 'inRange' && filterModel[alias].filterType === 'date'){
        let startDate = new Date(filterModel[alias].dateFrom);
        let endDate = new Date(filterModel[alias].dateTo);
        if(startDate > endDate){
          const dateHolder = filterModel[alias].dateTo;
          filterModel[alias].dateTo = filterModel[alias].dateFrom;
          filterModel[alias].dateFrom = dateHolder;
        }
      }
      // switch number values if needed
      if(filterModel[alias].type === 'inRange' && filterModel[alias].filterType === 'number' && filterModel[alias].filterTo < filterModel[alias].filter){
        const numHolder = filterModel[alias].filterTo;
        filterModel[alias].filterTo = filterModel[alias].filter;
        filterModel[alias].filter = numHolder;
      }
      // move filterModel data into new filter model with updated alias
      const qualifiedName: string = aliasMapping[alias] || alias;
      translatedFilters[qualifiedName] = filterModel[alias];
    }
    return translatedFilters;
  }


  onGridReady(params: GridReadyEvent<StoreReport>){
    const dataSource: IServerSideDatasource = {
      getRows: (params: IServerSideGetRowsParams<any, any> & { sortModel: SortModelItem[], filterModel: any}) => {
        const sortModel = params.request.sortModel;
        let filterModel : AdvancedFilterModel | null | FilterModel = params.request.filterModel;
        filterModel = this.translateFilters(filterModel); 
        const url = this.buildUrl(params.request.startRow || 0, params.request.endRow || 0, sortModel, filterModel);
        //console.log(`the filterModel that will be sent is: ${JSON.stringify(filterModel)}`);
        

        this.gridApi = params.api;

        this.http.get<{ data: {data: StoreReport[]}, totalRows: number}>(url).subscribe(
          response => {
            if(Array.isArray(response.data.data)){
              params.success({ rowData: response.data.data, rowCount: response.totalRows})
            }
            // else{
            //   console.log('response.data.data is not an array, it is a...' + (typeof response.data))
            //   console.log(JSON.stringify(response))
            // }
          },
          error => {
            console.error('error getting store report data: ', error);
            params.fail();
          }
        )
      }
    }

    params.api.setGridOption('serverSideDatasource', dataSource);
  }

  private buildUrl(startRow: number, endRow: number, sortModel: SortModelItem[], filterModel: any): string {
    // Construct the URL with query parameters for startRow, endRow, filters, and sortModel
    const filters = encodeURIComponent(JSON.stringify(filterModel));
    const sort = encodeURIComponent(JSON.stringify(sortModel));
    return `${this.apiUrl}?startRow=${startRow}&endRow=${endRow}&filters=${filters}&sortModel=${sort}`;
  }

  exportToCSV() {
    var params = { columnSeparator: "|"}
    this.gridApi.exportDataAsCsv(params);
  }

  exportToExcel(){
    this.gridApi.exportDataAsExcel();
  }

  toggleTheme(){
    this.theme = this.theme === 'ag-theme-ulaap' ? 'ag-theme-ulaap-dark' : 'ag-theme-ulaap';
  }

  openDeliveryReports(){
    window.open('/delivery_reports');
  }

  openExceptionReports(){
    window.open('/exception_reports');
  }

  deliveryDayStatusFormatting(params: ICellRendererParams) {
    let statusTypes: string[] = []
    if (params.value != null) {
      statusTypes = params.value.split(",");
    }
    let buttonsHtml = '';
  
    for (let type of statusTypes) {
      let trimmedType = type.trim();
      let bgColor = '';
  
      if(trimmedType.toUpperCase().includes('LATE DATE')){
        trimmedType = 'LATE DATE';
        bgColor = '#FFF';
      }
      else if(trimmedType.toUpperCase().includes('EARLY DATE')){
        trimmedType = 'EARLY DATE';
        bgColor = '#FF0';
      }
      else if(trimmedType.toUpperCase().includes('ON DATE')){
        trimmedType = 'ON DATE';
        bgColor = '#0F0';
      }
  
      buttonsHtml += '<button class="btn dropdown-toggle button-text-wrapper" style="background-color:' + bgColor + ';border-radius:10px;font-weight:bold;">' + trimmedType + '</button> <br>';
    }
  
    let element = '<div class="btn-group">' + buttonsHtml + '</div>';
  
    return element;
  }

  deliveryTimeStatusFormatting(params: ICellRendererParams) {
    let statusTypes: string[] = []
    if (params.value != null) {
      statusTypes = params.value.split(",");
    }
    let buttonsHtml = '';

    for (let type of statusTypes) {
      let trimmedType = type.trim();
      let bgColor = '';

      if(trimmedType.toUpperCase().includes('LATE TIME')){
        trimmedType = 'LATE TIME';
        bgColor = '#FFF';
      }
      else if(trimmedType.toUpperCase().includes('EARLY TIME')){
        trimmedType = 'EARLY TIME';
        bgColor = '#FF0';
      }
      else if(trimmedType.toUpperCase().includes('EARLY DATE')){
        trimmedType = 'EARLY TIME';
        bgColor = '#FF0';
      }      
      else if(trimmedType.toUpperCase().includes('LATE DATE')){
        trimmedType = 'LATE TIME';
        bgColor = '#FFF';
      }      
      else if(trimmedType.toUpperCase().includes('ON TIME')){
        trimmedType = 'ON TIME';
        bgColor = '#0F0';
      }

      buttonsHtml += '<button class="btn dropdown-toggle button-text-wrapper" style="background-color:' + bgColor + ';border-radius:10px;font-weight:bold;">' + trimmedType + '</button> <br>';
    }

    let element = '<div class="btn-group">' + buttonsHtml + '</div>';

    return element;
  }

  fetchAndApplyGridState(){
    this.gridStateService.getUserGridState('store_reports').subscribe((state) => {
      if(state){
        this.initialState = state;
      }
      this.gridReady = true;
    },
    error => {
      console.error('Failed to fetch grid state:', error);
      this.gridReady = true;
    }
    )
  }

  onStateUpdated(params:StateUpdatedEvent<StoreReport>){
    if(params.sources.indexOf('columnSizing') > -1 || params.sources.indexOf('columnOrder') > -1){
      this.gridStateService.saveUserGridState('store_reports', params.state)
    }
  }

  private formatDateString(value: string | null): string {
    if (!value || isNaN(new Date(value).getTime())) return '';
    return value.split(' ')[0];
  }

  private formatTimeString(value: string | null): string {
    if (!value || isNaN(new Date(value).getTime())) return '';
    return new Date(value).toTimeString().split(' ')[0];
  }
}
